import { IImportComponents } from '../_types/interfaces';


const importSecureFile = async (data: FormData): Promise<void> => {
    return console.log(data);
};


export const fakeImportService: IImportComponents = {
    importSecureFile,
};